import React from 'react';
import FolderIcon from '@mui/icons-material/Folder';
import LinearProgress from '@mui/material/LinearProgress';
import Divider from '@mui/material/Divider';
import { CircularProgress } from '@mui/material';

const ProjectSummary = ({ loading, stats }) => {
  const total = stats?.totals?.totalProjects || 0;
  const archived = stats?.totals?.archivedProjects || 0;
  const finished = stats?.statusCounts?.finished || 0;
  const ongoing = stats?.statusCounts?.in_progress || 0;

  const totalAttachments = stats?.attachments?.totalAttachments || 0;
  const averageAttachmentsPerProject = stats?.attachments?.averageAttachmentsPerProject || 0;

  return (
    <div className="UserSummary">
      <div className="summaryContainer">
        <div className="summary">
          <div className="number">{loading ? <CircularProgress size={30} /> : total}</div>
          <div className="text">Total Projects</div>
        </div>
        <div className="icon">
          <FolderIcon color="primary" fontSize="large" />
        </div>
      </div>
      <Divider />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Finished:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : finished}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : (finished / total) * 100}
          title={loading || total === 0 ? 0 : `${Math.floor((finished / total) * 100)}%`}
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Archived:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : archived}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : (archived / total) * 100}
          title={loading || total === 0 ? 0 : `${Math.floor((archived / total) * 100)}%`}
        />
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Ongoing:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : ongoing}</div>
        </div>
        <LinearProgress
          variant="determinate"
          value={loading || total === 0 ? 0 : (ongoing / total) * 100}
          title={loading || total === 0 ? 0 : `${Math.floor((ongoing / total) * 100)}%`}
        />
      </div>
      <Divider sx={{ m: 1 }} />
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Total Attachments:</div>{' '}
          <div>{loading ? <CircularProgress size={10} /> : totalAttachments}</div>
        </div>
      </div>
      <div className="activeUsersBar">
        <div className="barTexts">
          <div className="barTitle">Avg / Project:</div>{' '}
          <div>
            {loading ? <CircularProgress size={10} /> : averageAttachmentsPerProject.toFixed(2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSummary;
